import Vue from 'vue'
Vue.filter('toFixed', number => {
	let sNumber = String(number)
	if (
		sNumber.indexOf('.') > -1 &&
		sNumber.slice(sNumber.indexOf('.') + 1).length > 2
	) {
		let sn = sNumber.slice(0, sNumber.indexOf('.'))
		let en = sNumber.slice(sNumber.indexOf('.') + 1)
		if (en.indexOf('9999999') == 2 || en.indexOf('9999999') == 1) {
			en = Number(en.slice(0, 2)) + 1 + ''
		} else {
			en = en.slice(0, 2)
		}
		return Number(sn + '.' + en)
	} else {
		return Number(number).toFixed(2)
	}
})
